<script>
    import TextEditor from "../../Common/TextEditor.svelte";
    import Button from "./Button.svelte";
    import {getStyleValue} from "../../Common/tools"

    let focused = null;

    export let data, meta, globalStyle, onChange;

    $: if (!data.buttonStyle) data.buttonStyle = {};

    function change(value) {
      onChange();
      data = Object.assign({}, data, {content: value});
    }
</script>
<tr>
    <th class="column column-st" width="{getStyleValue(globalStyle.width, 600)}">
        <TextEditor onChange={change} meta={meta} data={data.content} emailEditor={true} />
        <Button bind:data={data} meta={meta} globalStyle={globalStyle} isChild={true} onChange={onChange}/>
    </th>
</tr>